import { ReimbursementReport } from "~/providers/components";

export const LeadPatientProgressNote = () => {
  return <ReimbursementReport />;
};
